import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../../../assets/img/logo.png";
import { useAuth } from "../../../../../contexts/AuthContext";
import usePersistentState from "../../../../../hooks/usePersistentState";
import SideNav from "../../../../shares/sideNav/SideNav";
import SideNavDrawer from "../../../../shares/sideNav/SideNavDrawer";
import { STUDENT_NAV, studentFooterNav } from "./navItems";

const EXPANDED = "w-[26rem]";
const COLLAPSED = "w-[7.2rem]";

// See the admin sidebar: the logo is hidden while collapsed rather than scaled.
function Brand({ collapsed }) {
    if (collapsed) return null;

    return (
        <Link
            to="/"
            replace
            className="flex items-center rounded-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
            <img className="h-[4rem]" src={Logo} alt="عطار" />
        </Link>
    );
}

function RightSidebar() {
    const [collapsed, setCollapsed] = usePersistentState(
        "attar.sidenav.collapsed",
        false
    );
    const navigate = useNavigate();
    const { loginDispatch } = useAuth();

    const logoutFunc = () => {
        loginDispatch({ type: "LOGOUT" });
        navigate("/");
    };

    const footerItems = studentFooterNav(logoutFunc);

    return (
        <>
            {/* Fixed, not in flow. As a flex child it consumed a slot in the
                dashboard row and scrolled out of reach on long pages. */}
            <div className="fixed start-sm top-sm z-40 md:hidden">
                <SideNavDrawer
                    items={STUDENT_NAV}
                    footerItems={footerItems}
                    ariaLabel="منوی کاربر"
                    brand={<Brand collapsed={false} />}
                />
            </div>

            <aside
                aria-label="منوی کاربر"
                className={`sticky top-0 hidden h-screen shrink-0 border-e border-rule-subtle bg-surface transition-[width] duration-200 motion-reduce:transition-none md:block ${
                    collapsed ? COLLAPSED : EXPANDED
                }`}
            >
                <SideNav
                    items={STUDENT_NAV}
                    footerItems={footerItems}
                    collapsed={collapsed}
                    onToggle={setCollapsed}
                    ariaLabel="منوی کاربر"
                    brand={<Brand collapsed={collapsed} />}
                />
            </aside>
        </>
    );
}

export default RightSidebar;
